/* components/patterns/planPrice.js — подпись нулевой цены на карточке тарифа.

   Закрытый тариф (is_private) с нулевой ценой выдан по договору и оплачен вне
   платформы (контракт Family Garden): «Бесплатно» на нём говорило бы клиенту
   неправду. Закрытый тариф с ценой продаётся по именной ссылке — у него цена как
   есть, а публичные бесплатные (демо, «Быстрый старт») остаются «Бесплатно». */

export const FREE_PRICE_LABEL = 'Бесплатно';
export const CONTRACT_PRICE_LABEL = 'По договору';

export function isContractPlan(plan) {
  return !!plan && plan.is_private === true && Number(plan.price_rub) === 0;
}

export function zeroPriceLabel(plan) {
  return isContractPlan(plan) ? CONTRACT_PRICE_LABEL : FREE_PRICE_LABEL;
}
